import React from 'react';

import { Provider } from 'react-redux';
import configureStore from './store/configure';

import Settings from './index';

export default function CommissionPlanSettings({ ...props }) {
  return (
    <Provider store={configureStore(props)}>
      <Settings/>
    </Provider>
  );
}
